import React from 'react'
import  './home.css'
import Social from './social'
import Data from './Data'
import ScrollDown from './ScrollDown'

export default function home() {
  const styles ="";
  return (
    <section className='home section' id='home'>
      <div className="home__container container grid">
        <div className="home__content grid">
          <Social></Social>
          <div className="home__img">
          </div>
          <Data></Data>
        </div>
        <ScrollDown/>
      </div>
    </section>
  )
}
